import React from 'react';

import type { CardId } from '@vlabs/api/artemy/model';
import { PlusIcon } from '@vlabs/icons';
import { Control, useModal } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { createCardFormSubmitHandlerPoint3 } from '../../entities/cards/create-card';
import { CreateCardFormPoint3 } from '../../entities/cards/create-card/create-card-form/CreateCardForm.point3';
import type { TCreateCardFormData } from '../../entities/cards/create-card/types.point3';

interface CreateCardButtonProps extends Omit<ButtonProps, 'onClick'> {
  onCreateCard?: (cardId: CardId) => void;
  defaultValues?: Partial<TCreateCardFormData>;
}

export function CreateCardButtonPoint3({
  onCreateCard = undefined,
  defaultValues = undefined,
  ...props
}: CreateCardButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const createCardModal = useModal({ size: 'small' });

  return (
    <React.Fragment>
      {createCardModal.wrap(
        <CreateCardFormPoint3
          defaultValues={defaultValues}
          onCancel={createCardModal.close}
          onSubmit={async (...args) => {
            const cardId = await createCardFormSubmitHandlerPoint3(args[0]);
            if (cardId === undefined) {
              toast.error(t('features:createCard.confirmation.error'));
              return;
            }
            createCardModal.close();
            toast.success(t('features:createCard.confirmation.success'));
            onCreateCard?.(cardId);
          }}
        />,
      )}

      <Control.Button
        icon={<PlusIcon />}
        onClick={createCardModal.open}
        {...props}
      >
        {props?.children ?? t('features:createCard.btn.add')}
      </Control.Button>
    </React.Fragment>
  );
}
